import { useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const CHIPS = ["Single-Season HR Record (21)", "CAA Player Of The Year", "Former SF Giants Org"];

export default function HighlightReel() {
  const videoRef = useRef(null);
  const [muted, setMuted] = useState(true);

  const toggleSound = () => {
    const v = videoRef.current;
    if (!v) return;
    v.muted = !v.muted;
    if (v.paused) v.play();
    setMuted(v.muted);
  };

  return (
    <section className="border-b border-zinc-800 bg-[#0B0B0C]" data-testid="highlight-reel-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <Reveal>
          <div className="flex items-center gap-4 mb-8">
            <span className="section-label">The Work</span>
            <span className="h-px flex-1 bg-zinc-800" />
            <span className="text-xs uppercase tracking-[0.3em] text-zinc-500 font-mono2">
              Highlight Reel
            </span>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="flex flex-wrap gap-2 mb-4">
            {CHIPS.map((c) => (
              <span
                key={c}
                className="border border-[#CCFF00]/40 px-3 py-1.5 text-[10px] uppercase tracking-[0.2em] text-[#CCFF00] font-mono2"
              >
                {c}
              </span>
            ))}
          </div>
          <div
            className="relative border border-zinc-800 overflow-hidden"
            data-testid="highlight-reel-video"
          >
            <video
              ref={videoRef}
              src="/videos/highlight-reel.mp4"
              poster="/videos/highlight-reel-poster.jpg"
              autoPlay
              muted
              loop
              playsInline
              className="w-full aspect-video object-cover"
            />
            <button
              onClick={toggleSound}
              data-testid="reel-sound-toggle"
              aria-label={muted ? "Unmute highlight reel" : "Mute highlight reel"}
              className="absolute bottom-3 right-3 sm:bottom-4 sm:right-4 flex items-center gap-2 bg-[#0B0B0C]/85 backdrop-blur border border-zinc-700 px-4 py-2.5 text-[10px] uppercase tracking-[0.2em] font-mono2 text-white hover:border-[#CCFF00] hover:text-[#CCFF00] transition-colors duration-300"
            >
              {muted ? <VolumeX className="w-4 h-4" /> : <Volume2 className="w-4 h-4 text-[#CCFF00]" />}
              {muted ? "Sound On" : "Sound Off"}
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
